// 广告标实验key
export const AdFlagExpKeyMap = {
  DOT: new Set(['A', 'B', 'E']),
  AD: new Set(['C']),
  SPONSOR: new Set(['D']),
};
